/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Add_Bacnet_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a device ID" |
*
* @param {Module_Add_Bacnet_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_add_bacnet_placeholder = /** @type {((inputs?: Module_Add_Bacnet_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Add_Bacnet_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enter a device ID")
	return /** @type {LocalizedString} */ ("Saisissez un ID")
});